import React from "react";

/**
 * Empêche la traduction automatique (Google/Chrome…) du contenu.
 * À utiliser pour tous les noms propres issus de la base : noms de chevaux,
 * pedigrees, lieux, étalon sélectionné, race, marque, noms de personnes…
 *
 * Combine l'attribut HTML standard `translate="no"` et la classe `notranslate`
 * pour une compatibilité maximale entre navigateurs.
 *
 * Usage :
 *   <NoTranslate>{lot.name}</NoTranslate>
 *   <NoTranslate as="h4">{lot.pedigree.gen1.father}</NoTranslate>
 */
export default function NoTranslate({ as: Tag = "span", className, children, ...rest }) {
  return (
    <Tag
      translate="no"
      className={className ? `notranslate ${className}` : "notranslate"}
      {...rest}
    >
      {children}
    </Tag>
  );
}
